import { Component, OnDestroy, OnInit } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import { Subject, Subscription } from "rxjs";
import { debounceTime, distinctUntilChanged } from "rxjs/operators";
import { MatTableDataSource } from "@angular/material/table";
import { PageEvent } from "@angular/material/paginator";
import { STORAGE_KEY_ID_PERFIL } from "src/app/storageCore/constStorageKeys";
import storageX from "src/app/storageCore/storageX";
import { Router } from "@angular/router";
import { DatePipe } from "@angular/common";
import { AnalyzeTripService } from "src/app/services/analyze-trip.service";
import { MinioService } from "src/app/services/minio.service";
import { MatDialog } from "@angular/material/dialog";
import { PermissionsService } from "src/app/helpers/permissions.service";

@Component({
  selector: "app-analyze-report-historic",
  templateUrl: "./analyze-report-historic.component.html",
  styleUrls: ["./analyze-report-historic.component.scss"],
})
export class AnalyzeReportHistoricComponent implements OnInit, OnDestroy {
  public errorMessage;
  public analyzeReportHistoricPage: any;
  public analyzesManagers: MatTableDataSource<any> =
    new MatTableDataSource<any>();
  public tableColumns: string[];
  public actualPage: PageEvent;
  public permissions: [];
  public typeFieldSelect = [
    { name: "Número Pacote", value: "PACKAGE" },
    { name: "Motorista", value: "DRIVER" },
    { name: "Placa", value: "PLATE" },
    { name: "Base Opera.", value: "BASE" },
    { name: "Nome Operador", value: "OPERATOR" },
  ];

  public filter = "";
  public field = "";
  public profile = "";
  public typeFieldFilterSelected;
  private intervalId: any;
  private filterSearch$ = new Subject<string>();
  private filterSearchSubscription: Subscription;
  private readonly filterDebounceMs = 400;

  constructor(
    private spinner: NgxSpinnerService,
    public router: Router,
    private analyzeTripService: AnalyzeTripService,
    private minioService: MinioService,
    public dialog: MatDialog,
    private datePipe: DatePipe,
    public permissionService: PermissionsService
  ) {}

  ngOnInit(): void {
    this.permissions = this.permissionService.getPermissions();
    this.profile = storageX.whereKeyIs(STORAGE_KEY_ID_PERFIL).get();

    this.typeFieldFilterSelected = this.typeFieldSelect[0].value;
    this.field = this.typeFieldFilterSelected;
    this.initialPage();
    this.setupFilterDebounce();
    this.loadReports(this.actualPage, this.filter, this.field);
    this.loadTableDefinitions();
    //this.startCallingLoadReports();
  }

  private setupFilterDebounce(): void {
    this.filterSearchSubscription = this.filterSearch$
      .pipe(debounceTime(this.filterDebounceMs), distinctUntilChanged())
      .subscribe(() => {
        this.actualPage.pageIndex = 0;
        this.loadReports(this.actualPage, this.filter, this.field, true);
      });
  }

  ngOnDestroy(): void {
    this.stopCallingLoadReports();
    this.filterSearchSubscription?.unsubscribe();
    this.filterSearch$.complete();
    this.spinner.hide();
  }

  // private startCallingLoadReports(): void {
  //   console.log("Data atual:", new Date());
  //   this.intervalId = setInterval(() => {
  //     this.loadReports(this.actualPage, this.filter, this.field);
  //   }, 30000); // Chama o método loadReports a cada 30 segundos
  // }

  private stopCallingLoadReports(): void {
    clearInterval(this.intervalId); // Para de chamar loadReports
  }

  private loadReports(
    page: PageEvent,
    name: string,
    field: string,
    showSpinner = true
  ): void {
    if (showSpinner) {
      this.spinner.show();
    }

    this.analyzeTripService
      .getAllAnalyzeReportHistoric(this.profile, page, name, field)
      .subscribe(
        (t) => {
          this.analyzeReportHistoricPage = t;
          this.analyzesManagers = new MatTableDataSource<any>(
            this.analyzeReportHistoricPage.content
          );
          if (showSpinner) {
            this.spinner.hide();
          }
        },
        (error) => {
          console.log("Erro ao obter as analises do operador");
          if (showSpinner) {
            this.spinner.hide();
          }
        }
      );
  }

  applyFilter(): void {
    this.filterSearch$.next(this.filter);
  }

  fieldFilter(): void {
    this.field = this.typeFieldFilterSelected;
    this.filter = "";
  }

  private loadTableDefinitions(): void {
    this.tableColumns = [
      "packageNumber",
      "dateStart",
      "dateEnd",
      "operationalBase",
      "companyDestiny",
      "driverName",
      "plate",
      "OperadorName",
      "operatorHandling",
      "managerName",
      "supervisorName",
      "treatManagerName",
      "descriptionManager",
      "finishedWithoutInfractions",
    ];

    if (
      this.permissionService.hasPermission(
        "ANALYZE_MINIO_FUNCIONALIDADE",
        this.permissions
      )
    ) {
      this.tableColumns.push("filePdfAnalytical", "filePdfSynthetic");
    }
  }

  exportReport(element): void {
    this.minioService.exportReport(element).subscribe();
  }

  onChangePage(event: PageEvent): void {
    this.actualPage = event;
    this.loadReports(this.actualPage, this.filter, this.field);
  }

  openToTreatment(uuid: string) {
    const url = "/analise-supervisor/tratamento-operador/" + uuid;
    window.open(url, "_blank");
  }

  private initialPage(): void {
    this.actualPage = new PageEvent();
    this.actualPage.pageIndex = 0;
    this.actualPage.pageSize = 20;
  }
}
